import { render, staticRenderFns } from "./SingleAnswerStats.vue?vue&type=template&id=e506b6ba&scoped=true&"
import script from "./SingleAnswerStats.vue?vue&type=script&lang=ts&"
export * from "./SingleAnswerStats.vue?vue&type=script&lang=ts&"
import style0 from "./SingleAnswerStats.vue?vue&type=style&index=0&id=e506b6ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e506b6ba",
  null
  
)

export default component.exports